export const Invite = function({ url }) {
  return (
    <div class="relative flex min-h-screen flex-col justify-center overflow-hidden bg-gray-50 py-6 sm:py-12">
      <div class="relative bg-white px-6 pt-10 pb-8 shadow-xl ring-1 ring-gray-900/5 sm:mx-auto sm:max-w-lg sm:rounded-lg sm:px-10">
        <div class="mx-auto max-w-md">
          <div class="divide-y divide-gray-300/50">
            <div class="space-y-2 text-base leading-7 text-gray-600">
              <div class="border-b-2 text-lg font-thin">Invite Instructions</div>

              <div>Share the Meeting URL with others</div>

              <div class="rounded-md bg-black p-3 font-mono text-white">{url}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
